export const base_url = 'https://api.booqy.in/';
// export const base_url = 'http://localhost:8000/';